import "../App.css";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import Warning from "../components/Warning";
import React, { useEffect, useState } from "react";
import { Helmet, HelmetProvider } from "react-helmet-async";
import Modal from "../components/Modal";

const Photo = () => {
  const [DataHed, setDataHed] = useState("Loading");
  const [DataInc, setDataInc] = useState("Getting some data from our servers.");
  const [DataIncT, setDataIncT] = useState("...");
  const [DataDay, setDataDay] = useState(" ");
  const [DataLoc, setDataLoc] = useState("This should only take a moment.");
  const [DataFrm, setDataFrm] = useState("");
  const [DataNot, setDataNot] = useState("");
  const [DataImg, setDataImg] = useState("");
  const [LoadState, setLoadState] = useState("loadingMode");
  const [modalVisible, setModalVisible] = useState(false);

  async function getData() {
    try {
      const queryParameters = new URLSearchParams(window.location.search);
      const id = queryParameters.get("id");
      const response = await fetch("https://api.csfrederick.com/data/" + id, {
        mode: "cors",
      });
      const data = await response.json();
      const imgData = await fetch("https://api.csfrederick.com/image/" + id, {
        mode: "no-cors",
      });
      await imgData.blob();
      setDataImg("https://api.csfrederick.com/image/" + id);
      setLoadState("loadedMode");
      setDataHed("" + data[id]["headerData"]);
      setDataInc("Includes: " + data[id]["includes"]);
      setDataIncT("Includes: " + data[id]["includes"]);
      setDataDay("Taken on: " + data[id]["timeDate"]);
      setDataLoc("Taken at: " + data[id]["location"]);
      setDataFrm("Format: " + data[id]["format"]);
      setDataNot("" + data[id]["notice"]);
    } catch (err) {
      setDataHed("FAILED");
    }
  }

  useEffect(() => { getData(); }, []);

  const openModal = () => setModalVisible(true);
  const closeModal = () => setModalVisible(false);

  var shown = true;
  const queryParameters = new URLSearchParams(window.location.search);
  const id = queryParameters.get("id");
  var updateableText = "Keep your ID safe, as anyone with it can view this page. Click this message to show.";
  const [updateData, setUpdate] = useState(updateableText);

  function handleClick() {
    if (shown) {
      updateableText = "Keep your ID safe, as anyone with it can view this page. Your ID is: " + id + ".";
      setUpdate(String(updateableText));
      shown = false;
    } else {
      updateableText = "Keep your ID safe, as anyone with it can view this page. Click this message to show.";
      setUpdate(String(updateableText));
      shown = true;
    }
  }

  const metaRows = [
    { label: "Includes", value: DataInc.replace("Includes: ", "") },
    { label: "Taken on", value: DataDay.replace("Taken on: ", "") },
    { label: "Location", value: DataLoc.replace("Taken at: ", "") },
    { label: "Format",   value: DataFrm.replace("Format: ", "") },
    { label: "Notice",   value: DataNot },
  ].filter(r => r.value && r.value !== "undefined" && r.value.trim() !== "");

  return (
    <div className="App" style={{ margin: "-8px" }}>
      <HelmetProvider>
        <Helmet>
          <title>Polaroid of {DataHed}</title>
          <meta
            name="Polaroid Photo"
            content="A canvas of a single moment."
            description="A canvas of a single moment."
            author="Jack Frederick"
          />
        </Helmet>
      </HelmetProvider>

      <Warning />
      <Navbar />

      <header className="Home">
        <div className="photoSpacer" />
        <div className="screenBox">

          {/* Image with glow halo */}
          <div className="photo-enter-image" style={{ position: "relative", display: "inline-block" }}>
            <div style={{
              position: "absolute",
              inset: "-20px",
              borderRadius: "inherit",
              background: "radial-gradient(ellipse at 50% 50%, rgba(160,110,255,0.3) 0%, transparent 70%)",
              filter: "blur(20px)",
              zIndex: 0,
              pointerEvents: "none",
            }} />
            <div className={"container " + LoadState}>
              <div className="dash uno" />
              <div className="dash dos" />
              <div className="dash tres" />
              <div className="dash cuatro" />
            </div>
            <img
              src={DataImg}
              className="Person-logo"
              alt=""
              onClick={openModal}
              style={{
                cursor: "pointer",
                position: "relative",
                zIndex: 1,
                boxShadow: "0 0 32px 8px rgba(160,110,255,0.22), 0 0 80px 20px rgba(120,80,220,0.10)",
                borderRadius: "12px",
                transition: "box-shadow 0.3s ease, transform 0.22s cubic-bezier(0.22,1,0.36,1)",
              }}
            />
          </div>

          {/* Data card — two column grid */}
          <div className="photo-enter-card photo-data-card">
            <p className="Homethick photo-data-title">{DataHed}</p>
            <div className="photo-meta-grid">
              {metaRows.map(({ label, value }) => (
                <React.Fragment key={label}>
                  <span className="photo-meta-label">{label}</span>
                  <span className="photo-meta-value">{value}</span>
                </React.Fragment>
              ))}
            </div>
          </div>

          <div className="photoSpacer" />
        </div>

        <br />

        <p className="Homesmall photo-enter-footer">
          Images are not available without the picture's ID or the physical image tag.
        </p>
        <p
          className="Homesmall photo-enter-footer"
          onClick={handleClick}
          style={{ cursor: "pointer", opacity: 0.7, transition: "opacity 0.2s ease" }}
        >
          {updateData}
        </p>
        <p className="Homemini photo-enter-footer" style={{ animationDelay: "0.9s" }}>
          If you have any concerns with your picture or if there is incorrect
          data shown above, contact me to get it resolved.
        </p>
      </header>

      <div className="photoSpacer" />
      <div className="photoSpacer" />
      <Footer />

      {modalVisible && (
        <Modal
          images={[DataImg]}
          currentImageIndex={0}
          onClose={closeModal}
        />
      )}
    </div>
  );
};

export default Photo;